
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M12 2a10 10 0 1010 10A10 10 0 0012 2zm6.93 6H16a15.65 15.65 0 00-1.38-3.56A8 8 0 0118.92 8zM12 4a14.09 14.09 0 011.91 4h-3.82A14.09 14.09 0 0112 4zM4.26 14a7.82 7.82 0 010-4h3.38a16.52 16.52 0 00-.14 2 16.52 16.52 0 00.14 2zm.82 2H8a15.65 15.65 0 001.38 3.56A8 8 0 015.08 16zM8 8H5.08a8 8 0 014.33-3.56A15.65 15.65 0 008 8zm4 12a14.09 14.09 0 01-1.91-4h3.82A14.09 14.09 0 0112 20zm2.34-6H9.66a14.71 14.71 0 01-.16-2 14.58 14.58 0 01.16-2h4.68a14.58 14.58 0 01.16 2 14.71 14.71 0 01-.16 2zm.25 5.56A15.65 15.65 0 0016 16h3a8 8 0 01-4.41 3.56zM16.36 14a16.52 16.52 0 00.14-2 16.52 16.52 0 00-.14-2h3.38a7.82 7.82 0 010 4z"}})])
          )
        }
      }
    